var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 11H17.5V20H15.5V11ZM13.5 2H19.5V4H13.5V2Z",
    fill: "#0D216D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4999 9.00011L27.0799 7.59011L24.8299 9.84011C22.9881 7.71314 20.3977 6.37755 17.5968 6.11082C14.7959 5.84409 11.9999 6.66675 9.78973 8.40786C7.57958 10.149 6.12521 12.6747 5.7288 15.4602C5.33238 18.2457 6.0244 21.0768 7.66107 23.3654C9.29774 25.654 11.7532 27.224 14.5173 27.7492C17.2814 28.2745 20.1417 27.7146 22.5037 26.1859C24.8658 24.6572 26.548 22.2772 27.201 19.5404C27.8539 16.8037 27.4274 13.9206 26.0099 11.4901L28.4999 9.00011ZM16.4999 26.0001C14.7199 26.0001 12.9798 25.4723 11.4998 24.4833C10.0198 23.4944 8.86621 22.0888 8.18502 20.4443C7.50384 18.7997 7.32561 16.9901 7.67287 15.2443C8.02014 13.4985 8.87731 11.8948 10.136 10.6362C11.3947 9.37748 12.9983 8.52031 14.7441 8.17305C16.49 7.82578 18.2996 8.00401 19.9441 8.6852C21.5886 9.36639 22.9942 10.5199 23.9832 12C24.9721 13.48 25.4999 15.2201 25.4999 17.0001C25.4999 19.3871 24.5517 21.6762 22.8639 23.3641C21.1761 25.0519 18.8869 26.0001 16.4999 26.0001Z",
    fill: "#0D216D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTimer);
export default __webpack_public_path__ + "static/media/ic-timer.7d53ea21fee54ca92cad79d9107e3ce5.svg";
export { ForwardRef as ReactComponent };